import { Stack } from "@mui/material";
import { parseAsStringEnum, useQueryState } from "nuqs";
import { useParams } from "react-router";

import { GqlPlannerShiftCompletionStatus } from "~/__generated__";
import GaiaPageLayoutColumn from "~/modules/app/components/GaiaPageLayoutColumn";
import UserBadge from "~/modules/user/components/UserBadge";
import FieldworkerShifts from "~/shared/components/FieldworkerShifts";
import PlannerShiftCompletionStatusSelect from "~/shared/components/PlannerShiftCompletionStatusSelect";

import useUserShiftsScreen_GetData from "./api/useUserShiftsScreen_GetData";

export default function UserShiftsScreen() {
    const { userId } = useParams<{ userId: string }>();
    if (!userId) throw new Error("Need `userId` parameter to be available");

    const [plannerShiftCompletionStatusFilter, setPlannerShiftCompletionStatusFilter] = useQueryState(
        "plannerShiftCompletionStatus",
        parseAsStringEnum<GqlPlannerShiftCompletionStatus>(Object.values(GqlPlannerShiftCompletionStatus)),
    );

    const { data, loading, user } = useUserShiftsScreen_GetData({
        userId,
        plannerShiftCompletionStatus: plannerShiftCompletionStatusFilter,
        sortBy: "startTime",
        sortOrder: "desc",
    });

    if (user == null) return null;

    return (
        <GaiaPageLayoutColumn maxWidth="xl">
            <Stack rowGap={2} bgcolor={theme => theme.palette.background.paper} width="100%" p={2}>
                <UserBadge
                    profilePicture={user.profilePictureMedia?.url}
                    names={[user.firstName, user.lastName]}
                    showName
                    size={60}
                    nameTextVariant="h4"
                />
                <PlannerShiftCompletionStatusSelect
                    value={plannerShiftCompletionStatusFilter ?? undefined}
                    onChange={newStatus => setPlannerShiftCompletionStatusFilter(newStatus ?? null)}
                />
                <FieldworkerShifts data={data} loading={loading} />
            </Stack>
        </GaiaPageLayoutColumn>
    );
}
